import getOffsetTop from '../../utils/getOffsetTop';

let hasClass = function(element, cls) {
	return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
}

// let DEBUG_ID = 0;

export default function(elementToActivate, browser) {
	//event.scrollY
	var _offsetTop = 0;
	var _wWidth = 0;
	var _wHeight = 0;
	let elem = elementToActivate();
	// let _DEBUG_ID = DEBUG_ID++;

	let tryActivateElem = (event) => {
		// console.log(`[ID:${_DEBUG_ID}] tryActivateElem`);
		if (event && event.deltaY === 0) {
			return false;
		}

		// console.log(`[ID:${_DEBUG_ID}] tryActivateElem - running`);
		// let perf = performance.now() / 1000;
		// console.log(`[ID:${_DEBUG_ID}] START: ${perf}`);

		event = event || { scrollY: window.scrollY };

		// offsetTop is expensive, so we use a cached value if available
		// + invalidate if browser window is resized
		let offsetTop = _offsetTop;
		if (!offsetTop || (document.documentElement.clientHeight !== _wHeight || document.documentElement.clientWidth !== _wWidth)) {
			_wHeight = document.documentElement.clientHeight;
			_wWidth = document.documentElement.clientWidth;
			_offsetTop = offsetTop = getOffsetTop(elem);
		}

		let elementTrigger = offsetTop + 150;
		let shouldActivate = (event.scrollY + browser.window.height >= elementTrigger);

		if (shouldActivate) {
			//console.log(elem);
			//console.log(`(${event.scrollY + browser.window.height} >= ${elementTrigger})`);
			if (!hasClass(elem, 'active')) {
				elem.className += ' active';
			}

			browser.scroll.deregister(tryActivateElem);
		}

		// let newPerf = (performance.now() / 1000);
		// console.log(`[ID:${_DEBUG_ID}] END: ${newPerf} - DIFF: ${newPerf - perf}`);

		return shouldActivate;
	}



	return tryActivateElem;
};



/** WEBPACK FOOTER **
 ** ./frontend/components/timeline/scrollActivate.js
 **/